var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_18692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6475 4.5H1.89746C1.27721 4.5 0.772461 3.99525 0.772461 3.375V1.125C0.772461 0.50475 1.27721 0 1.89746 0H17.6475C18.2677 0 18.7725 0.50475 18.7725 1.125V3.375C18.7725 3.99525 18.2677 4.5 17.6475 4.5ZM1.89746 0.75C1.69046 0.75 1.52246 0.918 1.52246 1.125V3.375C1.52246 3.582 1.69046 3.75 1.89746 3.75H17.6475C17.8545 3.75 18.0225 3.582 18.0225 3.375V1.125C18.0225 0.918 17.8545 0.75 17.6475 0.75H1.89746Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 6.75H1.14746C0.940461 6.75 0.772461 6.582 0.772461 6.375C0.772461 6.168 0.940461 6 1.14746 6H11.6475C11.8545 6 12.0225 6.168 12.0225 6.375C12.0225 6.582 11.8545 6.75 11.6475 6.75Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 9H1.14746C0.940461 9 0.772461 8.832 0.772461 8.625C0.772461 8.418 0.940461 8.25 1.14746 8.25H11.6475C11.8545 8.25 12.0225 8.418 12.0225 8.625C12.0225 8.832 11.8545 9 11.6475 9Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 11.25H1.14746C0.940461 11.25 0.772461 11.082 0.772461 10.875C0.772461 10.668 0.940461 10.5 1.14746 10.5H11.6475C11.8545 10.5 12.0225 10.668 12.0225 10.875C12.0225 11.082 11.8545 11.25 11.6475 11.25Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 13.5H1.14746C0.940461 13.5 0.772461 13.332 0.772461 13.125C0.772461 12.918 0.940461 12.75 1.14746 12.75H11.6475C11.8545 12.75 12.0225 12.918 12.0225 13.125C12.0225 13.332 11.8545 13.5 11.6475 13.5Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 15.75H1.14746C0.940461 15.75 0.772461 15.582 0.772461 15.375C0.772461 15.168 0.940461 15 1.14746 15H11.6475C11.8545 15 12.0225 15.168 12.0225 15.375C12.0225 15.582 11.8545 15.75 11.6475 15.75Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_1881_18692",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 18H1.14746C0.940461 18 0.772461 17.832 0.772461 17.625C0.772461 17.418 0.940461 17.25 1.14746 17.25H11.6475C11.8545 17.25 12.0225 17.418 12.0225 17.625C12.0225 17.832 11.8545 18 11.6475 18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 18H1.14746C0.940461 18 0.772461 17.832 0.772461 17.625C0.772461 17.418 0.940461 17.25 1.14746 17.25H11.6475C11.8545 17.25 12.0225 17.418 12.0225 17.625C12.0225 17.832 11.8545 18 11.6475 18Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6475 17H1.14746V19H11.6475V17ZM1.14746 17C1.49275 17 1.77246 17.2797 1.77246 17.625H-0.227539C-0.227539 18.3843 0.388176 19 1.14746 19V17ZM1.77246 17.625C1.77246 17.9703 1.49275 18.25 1.14746 18.25V16.25C0.388176 16.25 -0.227539 16.8657 -0.227539 17.625H1.77246ZM1.14746 18.25H11.6475V16.25H1.14746V18.25ZM11.6475 18.25C11.3022 18.25 11.0225 17.9703 11.0225 17.625H13.0225C13.0225 16.8657 12.4067 16.25 11.6475 16.25V18.25ZM11.0225 17.625C11.0225 17.2797 11.3022 17 11.6475 17V19C12.4067 19 13.0225 18.3843 13.0225 17.625H11.0225Z",
    fill: "#4E4E4E",
    mask: "url(#path-7-inside-1_1881_18692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1475 11.25C14.7 11.25 13.5225 10.0725 13.5225 8.625C13.5225 7.1775 14.7 6 16.1475 6C17.595 6 18.7725 7.1775 18.7725 8.625C18.7725 10.0725 17.595 11.25 16.1475 11.25ZM16.1475 6.75C15.114 6.75 14.2725 7.5915 14.2725 8.625C14.2725 9.6585 15.114 10.5 16.1475 10.5C17.181 10.5 18.0225 9.6585 18.0225 8.625C18.0225 7.5915 17.181 6.75 16.1475 6.75Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1475 18C14.7 18 13.5225 16.8225 13.5225 15.375C13.5225 13.9275 14.7 12.75 16.1475 12.75C17.595 12.75 18.7725 13.9275 18.7725 15.375C18.7725 16.8225 17.595 18 16.1475 18ZM16.1475 13.5C15.114 13.5 14.2725 14.3415 14.2725 15.375C14.2725 16.4085 15.114 17.25 16.1475 17.25C17.181 17.25 18.0225 16.4085 18.0225 15.375C18.0225 14.3415 17.181 13.5 16.1475 13.5Z",
    fill: "#4E4E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_18692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.772461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.46a74f593ab560faaab8112774a3991a.svg";
export { ForwardRef as ReactComponent };